export default {
  Main: {
    Title: "Danh sách thanh toán",
    SearchFilter: "Tên | MST, MNS | Mã đơn vị",
  },
  List: {
    MerchantCode: "Mã đơn vị",
    MerchantName: "Tên đơn vị",
    TaxNo: "MST/MNS",
    TransactionTime: "Kỳ đối soát", // from - to
    PaymentDate: "Kỳ thanh toán",
    GroupTransSuccess: "GD thành công kỳ này",
    TotalQuantityTransSuccess: "Số lượng (1)",
    TotalAmountTransSuccess: "Giá trị (2)",
    GroupTransSuccessPrevious: "GD bổ sung kỳ này",
    TotalQuantityTransSuccessPrevious: "Số lượng (3)",
    TotalAmountTransSuccessPrevious: "Giá trị (4)",
    TotalAmountDeduct: "Số tiền bù trừ (5)",
    TotalFeeAmount: "Phí (6)",
    TotalJetpaypayToMerchant: "Tổng tiền thanh toán <br/> = (2) + (4) - (5) - (6)",
    GroupTransTransHold: "GD tạm giữ",
    TotalQuantityTransHold: "Số lượng",
    TotalAmountTransHold: "Giá trị",
    BankName: "Ngân hàng",
    BankAccountOwner: "Chủ tài khoản",
    BankAccountNumber: "STK",
    BranchName: "Chi nhánh",
    Status: "Tình trạng thanh toán",
  },

  ListDetaiTransactionControl: {
    TransactionDate: "Ngày giao dịch",
    DateMarkedHold: "Ngày ghi nhận",
    TransactionCode: "Mã giao dịch",
    Amount: "Giá trị giao dịch",
    FeeAmount: "Phí",
    Type: "Loại", // Loại giao dịch
    PaymentHold: "Cách thức", // cách giữ tiền khi phát sinh giao dịch gian lận..
  },

  Command: {
    MarkPaid: "Xác nhận thanh toán",
    Edit: "Sửa",
    Save: "Lưu",
    Close: "Đóng",
  },
  Message: {
    MarkPaidSuccess: "Xác nhận thanh toán thành công đơn vị {0}!",
    MarkPaidMultiSuccess: "Xác nhận thanh toán thành công {0} đơn vị!",
    Error: "Có lỗi xảy ra!",
    NotFound: "Không tìm đơn hàng!",
    ErrorAtLeast: "Vui lòng chọn ít nhất một đơn hàng chưa thanh toán!",
    ErrorStatusSelected: "Vui lòng chọn đơn hàng ở trạng thái chưa thanh toán!",
  },
  Detail: {
    Title: "Danh sách thanh toán chi tiết",
    ReportPaymentDetail: "Báo cáo thanh toán chi tiết",
    Add: "Thêm",
    Cancel: "Hủy bỏ",
    Save: "Lưu",
    Edit: "Sửa",
    BtnConfirm: "Xác nhận",
    BtnConfirmYes: "Đồng ý",
    BtnConfirmCancel: "Hủy bỏ",
    PaymentInfo: "TT thanh toán:",
    CreatedDate: "Ngày lập BB đối soát:",
    PaymentPeriodDate: "Kỳ đối soát:",
    BankAccountNumber: "Tài khoản:",
    BankAccountOwner: "Tên tài khoản:",
    BankName: "Ngân hàng:",
    BranchName: "Chi nhánh:",
  },
};
